module.exports = __webpack_public_path__ + "assets/img/about-us.bbb4abf5.jpg";